/** Browser input checks only. The server independently verifies every relationship. */
export function signingDocumentNumber(raw: string): number {
  let text = raw.trim()
  if (text.startsWith('https://')) {
    if (!/^https:\/\/b24-vg2xjj\.bitrix24\.eu\/crm\/type\/36\/details\/[1-9][0-9]*\/?$/.test(text)) throw new Error('Copia el enlace completo del documento de firma de A1Homes, sin parámetros ni rutas adicionales.')
    const url = new URL(text)
    if (url.origin !== 'https://b24-vg2xjj.bitrix24.eu' || url.username || url.password || url.search || url.hash) throw new Error('Usa el enlace del documento de firma de A1Homes, sin parámetros adicionales.')
    const match = /^\/crm\/type\/36\/details\/([1-9][0-9]*)\/?$/.exec(url.pathname)
    if (!match) throw new Error('Abre el documento en Firma electrónica y copia su enlace completo.')
    text = match[1]
  }
  if (!/^[1-9][0-9]*$/.test(text) || !Number.isSafeInteger(Number(text))) throw new Error('Indica el número del documento de firma o su enlace de Bitrix.')
  return Number(text)
}

export function validateReviewPdf(file: { type: string; size: number } | undefined, limit = 20_000_000): void {
  if (!file || file.type !== 'application/pdf' || file.size < 5 || file.size > limit) throw new Error(`Selecciona un PDF original válido de hasta ${limit / 1_000_000} MB.`)
}

export function completedSigningTime(raw: string, handoffAt: number | undefined, now = Date.now()): number {
  const value = raw ? Date.parse(raw) : NaN
  if (!Number.isSafeInteger(value) || handoffAt === undefined || value < handoffAt || value > now) throw new Error('Indica la fecha y hora de finalización del certificado, posterior a la preparación y no futura.')
  return value
}

/** Selecting the frozen package never reuploads a local file. Server checks stay authoritative. */
export async function prepareSigningSource<T extends string>(useReviewedPackage:boolean,file:File|undefined,upload:(file:File)=>Promise<T>):Promise<{useReviewedPackage:true}|{sourcePdfId:T}>{
  if(useReviewedPackage)return {useReviewedPackage:true}
  validateReviewPdf(file)
  return {sourcePdfId:await upload(file!)}
}
